import { SalasVipRaw, SalasVip } from "./types/salasVip";
import { fetchWithRetry } from "../client";
import { cmsLang, type Locale } from "@/i18n/config";
export async function fetchSalasVip(lang: Locale): Promise<SalasVip[]> {
  const res = await fetchWithRetry<{ data: SalasVipRaw[] }>(
    `/salas-vip?lang=${cmsLang(lang)}`
  );

  return res.data.map((item) => ({
    id: item.id,
    nombre: item.nombre,
    banner: item.banner,
    contenido: item.contenido.map((content) => ({
      img: content.img,
      link: content.link,
      title: content.title,
    })),
  }));
}
